import Reflux from 'reflux';
import ConfirmActions from 'flux/actions/ConfirmActions';
import { Map } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import keyBinder from 'shared/lib/keyBinder';

/**
 * ModalStore
 *
 * Keeps track of confirm visibility
 *
 */
export default Reflux.createStore({
  listenables: [ConfirmActions],

  mixins: [BaseMixin],

  init() {
    this.setState(null);
  },

  onCancel() {
    /**
     * Reactivate previous key bindings
     */
    keyBinder.setScope(this._lastKeyScope);

    this.setStateAndTrigger(null);
  },

  onPrompt(question, confirmAction, title = '', buttonOverride = {}) {
    this._lastKeyScope = keyBinder.getScope();

    /**
     * Suspend current key scope mode, so that any current hot keys don't work while in 'prompt' state
     */
    keyBinder.setScope('confirm');

    this.setStateAndTrigger(
      Map({ question, confirmAction, title, buttonOverride }),
    );
  },

  onConfirm() {
    var action = this.getInState('confirmAction');

    action();

    /**
     * Reactivate previous key bindings
     */
    keyBinder.setScope(this._lastKeyScope);

    this.setStateAndTrigger(null);
  },
});
